<section class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Medidas</h1>
    <add-button label="Nueva Medida" (onClick)="openEditForm()"></add-button>
</section>

<sau-table #sauTable [url]="url" contentList="list" contentTotal="count" pageParamName="page" contentTotal="total"
    [sizeInitialPage]="1" limitParamName="limit" [sizeBetweenPages]="1" [limit]="10" [headers]="headers"
    (deleteEvent)="openDeleteForm($event)" (editEvent)="openEditForm($event)"></sau-table>
